import React from 'react'
import { MdLightbulb, MdElectricBolt } from 'react-icons/md'
import { TbCircleDotFilled } from 'react-icons/tb'

export type Service = 'openai' | 'deepgram'
export type SpeechToTextModel = 'whisper-1' | 'nova-3'
export type LanguageModel = 'gpt-4o-mini' | 'gpt-4-turbo' | 'gpt-4o'

export interface ModelOption {
  service: Service
  serviceDisplay: string
  model: SpeechToTextModel | LanguageModel
  modelDisplay: string
  metaInformation?: string
  icon?: React.ReactNode
}

export const SPEECH_TO_TEXT_OPTIONS: ModelOption[] = [
  {
    service: 'openai',
    serviceDisplay: 'OpenAI',
    model: 'whisper-1',
    modelDisplay: 'Whisper',
  },
  {
    service: 'deepgram',
    serviceDisplay: 'Deepgram',
    model: 'nova-3',
    modelDisplay: 'Nova',
  },
]

export const LANGUAGE_MODEL_OPTIONS: ModelOption[] = [
  {
    service: 'openai',
    serviceDisplay: 'OpenAI',
    model: 'gpt-4o-mini',
    modelDisplay: 'GPT-4o Mini',
    icon: <MdElectricBolt />,
    metaInformation: 'fastest',
  },
  {
    service: 'openai',
    serviceDisplay: 'OpenAI',
    model: 'gpt-4-turbo',
    modelDisplay: 'GPT-4 Turbo',
    icon: <TbCircleDotFilled />,
    metaInformation: 'balanced',
  },
  {
    service: 'openai',
    serviceDisplay: 'OpenAI',
    model: 'gpt-4o',
    modelDisplay: 'GPT-4o',
    icon: <MdLightbulb />,
    metaInformation: 'most capable',
  },
]
